const config = {
    apiBaseUrl: 'https://api.mytowncode.com',
    codeOwnerApiUrl: 'https://codeowner.mytowncode.com:3002',
    codeManagerApiUrl: 'https://codes.mytowncode.com:3003'
};

export default config; 